import { DeliveryNote, DeliveryNoteTableColumn } from "../deliveryNote.interfaces"

export const deliveryNoteTransformer = (dn: DeliveryNote): DeliveryNoteTableColumn => ({
    key: dn._id,
    name: dn.deliveryNoteNumber,
    vendor: dn.vendor.name || "",
    dateOfIssue: dn.dateOfIssue,
    createdBy: dn.createdBy,
    linkedTo: [
        ...new Set(
            dn.lineItems // keep line breaks
                .filter((item) => !!item.purchaseOrderLink)
                .map((item) => item.purchaseOrderLink?.purchaseOrderNumber || ""),
        ),
    ],
})
